import React, { useEffect, useState } from "react";
import "./validateAPI.css";
import {
	Button,
	Divider,
	List,
	Paper,
	Typography,
} from "@mui/material";
import { getLoginToken } from "../../services/authenticationService";
import { apiValidationMapping } from "../../components/validateAPI/ValidateAPIRegistry";
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";
import * as Sentry from "@sentry/react";
import { openPopup } from "../../stateManagement/actions/popupActions";
import DefaultHeading from "../../components/heading/DefaultHeading";
import { useSelector } from "react-redux";
import { resetAll, setToken, } from "../../stateManagement/actions/validateAPIActions";
import store from "../../stateManagement/store";
import { MetaDataValidation } from "../../components/validateAPI/ValidateAPITypes";
import ValidateForm from "../../components/validateAPI/ValidateForm";
import ValidateAPIResponse from "../../components/validateAPI/ValidateAPIResponse";
import ValidateCollapse from "../../components/validateAPI/ValidateCollapse";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

const ValidateAPI = (): JSX.Element => {
	const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Validate API";
    const CUR_COMPONENT_COMMON="commonPortal";
	const [data, setData] = useState<any>([...apiValidationMapping]);
	const [currentSelectedResponse, setCurrentSelectedResponse] = useState<string | null>(null);
	const { apiResponses } = useSelector(() => store.getState().validateAPIState);

	const handleValidateClick = async (userName: string, password: string) => {
		const lob: string = EnvironmentRegistry.getCurrentLob() ?? "";
		try {
			if (
				!userName ||
				userName.trim() === "" ||
				!password ||
				password.trim() === ""
			){
				openPopup("Error","Input fileds cannot be empty");
				return -1; 
			}
			const token = await getLoginToken("", password, lob);
			if(token)setToken(token);
			return 1;
		} catch (err: any) {
			openPopup("Error", err.data.message);
			// Sentry.captureException(err);
			return -1;
		}
	};

	const downloadJsonFile = (fileName: string, jsonData: any) => {
		const jsonStr = JSON.stringify(jsonData, null, 2);
		const blob = new Blob([jsonStr], { type: "application/json" });
		const url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.download = fileName;
		link.click();
		URL.revokeObjectURL(url);
	};

	useEffect(() => {
		return () => {
			resetAll();
		}
	}, [])

	return (
		<div className="validateApi-wrapper">
			<div className="validateApi-header">
				<DefaultHeading heading="Banner Report" showDefaultBackButton />
			</div>

			<main className="validateApi-main">
				<Paper className="validateApi-main-aside">
					<ValidateForm handleValidateClick={handleValidateClick} />
				</Paper>

				<Paper className="fixed-header-wrapper validation-list-wrapper">
					<div className="validateApi-fixed-header-wrapper-header">
						<Typography
							className="bannerReportHeading"
							variant="h6"
							pl={1}
						>
							{translate(TranslationEnum.validate_api,"Validations List")}
						</Typography>
					</div>
					<Divider />
					<main className="validateApi-fixed-header-content-wrapper">
						<div className="validateApi-fixed-header-content-wrapper-content">
							<List className="data-list">
								{data.map(
									({ id, name, validations, apiId }: {
										id: string,
										name: string,
										validations: MetaDataValidation[],
										apiId: string
									}) => {
										return (
											<ValidateCollapse
												key={id}
												id={id}
												name={name}
												validations={validations}
												setCurrentSelectedResponse={
													setCurrentSelectedResponse
												}
												apiId={apiId}
											/>
										);
									}
								)}
							</List>
						</div>
					</main>
				</Paper>

				<Paper className="fixed-header-wrapper validation-response-wrapper">
					<div className="validateApi-fixed-header-wrapper-header">
						<Typography
							className="bannerReportHeading"
							variant="h6"
							pl={1}
						>
							{currentSelectedResponse ?? translate(TranslationEnum.validate_api,"Response")}
						</Typography>
						{currentSelectedResponse &&
							apiResponses &&
							apiResponses[currentSelectedResponse]?.type !==
							"error" && (
								<Button
									variant="outlined"
									size="small"
									onClick={() =>
										downloadJsonFile(
											currentSelectedResponse +
											" response",
											apiResponses[
											currentSelectedResponse
											]
										)
									}
								>
									Download
								</Button>
							)}
					</div>
					<Divider />
					<main className="validateApi-fixed-header-content-wrapper">
						<div className="validateApi-fixed-header-content-wrapper-content">
							<ValidateAPIResponse currentSelectedResponse={currentSelectedResponse} apiResponses={apiResponses} />
						</div>
					</main>
				</Paper>
			</main>
		</div>
	);
};

export default ValidateAPI;
